// extracted by mini-css-extract-plugin
export default {"cartIconContainer":"cartIcon_cartIconContainer__tiMF-","shoppingIcon":"cartIcon_shoppingIcon__m14XS","itemCount":"cartIcon_itemCount__lErOT"};